import { render, staticRenderFns } from "./DeviceInfoPeripherals.vue?vue&type=template&id=15982805&scoped=true"
import script from "./DeviceInfoPeripherals.vue?vue&type=script&lang=js"
export * from "./DeviceInfoPeripherals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15982805",
  null
  
)

export default component.exports